import { Injectable } from '@angular/core';
import { ADPConfigService, ADPResourceService, AppLoadService, LogService, PersistanceStrategyService, ResourcesLoaderService } from 'digital-core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PGHAppLoadService extends AppLoadService {
  public isSiteResourcesLoaded: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);

  public constructor(
    public resourcesLoader: ResourcesLoaderService,
    public resourceService: ADPResourceService,
    public logService: LogService,
    public configService: ADPConfigService,
    public persistanceStrategyService: PersistanceStrategyService
  ) {
    super(resourcesLoader, resourceService, logService, configService, persistanceStrategyService);
  }
}
